<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
  props: {
    prop_edit: {
      default: true,
    }
  },
  components: { DatePicker },
  data() {
    return {
      catalogue: new Catalogue(),
      errors: {},
      send: false,
      load: false,
      clients: [],
      providers: [],
      form: {
        id: '',
        contract_id: '',
        contract_type_id: '',
        provider_id: '',
        client_id: '',
        service_description: '',
        start_date: '',
        end_date: '',
        payment_period_id: '',
        status: 1,
        terms: '',
        concepts: [
        ],
      },
    }
  },
  methods: {
    moneyToNumber(val) {
      if (val === null || val === undefined) return 0;
      const n = String(val).replace(/,/g, '');
      return parseFloat(n || 0);
    },

    calcLineTotal(item) {
      const amount = this.moneyToNumber(item.amount);
      const qty = parseInt(item.quantity || 0);
      const total = amount * qty;
      item.total = isNaN(total) ? 0 : Number(total.toFixed(2));
      this.calcHeaderTotal();
    },

    calcHeaderTotal() {
      const sum = (this.form.concepts || []).reduce((acc, it) => {
        return acc + (this.moneyToNumber(it.total) || 0);
      }, 0);
      this.form.total_ui = Number(sum.toFixed(2));
    },

    addConceptRow() {
      const nextOrder = (this.form.concepts?.length || 0) + 1;
      this.form.concepts.push({
        id: '',
        concept: '',
        amount: '',
        quantity: 1,
        order: nextOrder,
        total: 0,
      });
    },

    removeConceptRow(index) {
      this.form.concepts.splice(index, 1);
      this.form.concepts.forEach((c, i) => c.order = i + 1);
      this.calcHeaderTotal();
    },

    closedModal() {
      this.errors = {};
      this.send = false;
      this.load = false;

      this.form = {
        id: '',
        contract_id: '',
        contract_type_id: '',
        provider_id: '',
        client_id: '',
        service_description: '',
        start_date: '',
        end_date: '',
        payment_period_id: '',
        status: 1,
        terms: '',
        concepts: [],
        total_ui: 0,
      };

      this.$modal.hide('serviceContractForm');
    },

    async openForCreate(payload = {}) {
      this.closedModal(); 
      
      this.errors = {};
      this.send = false;
      this.load = false;

      this.form.contract_id = payload.contract_id || '';
      this.form.provider_id = payload.provider_id || '';
      this.form.client_id = payload.client_id || '';
      this.form.contract_type_id = payload.contract_type_id || '';
      this.form.status = payload.status ?? 1;

      // Al menos 1 renglón
      this.addConceptRow();

      this.$modal.show('serviceContractForm');
    },

    async openForEdit(id) {
      this.errors = {};
      this.send = false;
      this.load = true;

      try {
        const { data } = await request.get(`/service-contracts/${id}`);
        if (data) {
          // Si tu show devuelve {data: {...}} ajusta aquí.
          const row = data.data ? data.data : data;

          this.form.id = row.id;
          this.form.contract_id = row.contract_id;
          this.form.contract_type_id = row.contract_type_id;
          this.form.provider_id = row.provider_id;
          this.form.client_id = row.client_id;
          this.form.service_description = row.service_description;
          this.form.start_date = row.start_date;
          this.form.end_date = row.end_date;
          this.form.payment_period_id = row.payment_period_id;
          this.form.status = row.status;
          this.form.terms = row.terms;

          // conceptos (si los mandas desde backend)
          this.form.concepts = (row.concepts || []).map((c) => ({
            id: c.id,
            concept: c.concept,
            amount: c.amount,
            quantity: c.quantity,
            total: c.total || 0,
          }));

          if (this.form.concepts.length === 0) {
            this.addConceptRow();
          }

          this.calcHeaderTotal();
          this.$modal.show('serviceContractForm');
        }
      } catch (error) {
        this.errors = {};
        if (error.response) {
          this.errors = await this.errorNotification(error);
        }
      } finally {
        this.load = false;
      }
    },

    async saveServiceContract() {
      this.send = true;
      this.errors = {};

      if (!this.form.concepts || this.form.concepts.length === 0) {
        this.$swal({ icon: 'error', title: 'Faltan conceptos', text: 'Agrega al menos un concepto.' });
        this.send = false;
        return;
      }

      const payload = {
        contract_id: this.form.contract_id,
        contract_type_id: this.form.contract_type_id || null,
        provider_id: this.form.provider_id || null,
        client_id: this.form.client_id || null,
        service_description: this.form.service_description || null,
        start_date: this.form.start_date,
        end_date: this.form.end_date || null,
        payment_period_id: this.form.payment_period_id || null,
        status: this.form.status ?? 1,
        terms: this.form.terms || null,
        concepts: this.form.concepts.map((c) => ({
          id: c.id || null,
          concept: c.concept,
          amount: this.moneyToNumber(c.amount),
          quantity: parseInt(c.quantity || 0),
        }))
      };

      let _endpoint = '/service-contracts';

      try {
        let response;
        if (this.form.id) {
          payload._method = 'PUT';
          _endpoint = `/service-contracts/${this.form.id}`;
          response = await request.post(_endpoint, payload).then(r => r);
        } else {
          response = await request.post(_endpoint, payload).then(r => r);
        }

        if (response && response.data) {
          this.successNotification(response.data.message || 'Guardado correctamente.');
          this.closedModal();
          Event.$emit('event-load-service-contracts');
        }
      } catch (error) {
        this.send = false;
        this.errors = {};
        if (error.response) {
          this.errors = await this.errorNotification(error);
        }
      } finally {
        this.send = false;
      }
    },

    ...mapActions({
      errorNotification: 'alert/error',
      successNotification: 'alert/success',
    }),
  },
  async mounted() {
    await this.catalogue.getContractServicesType();
    await this.catalogue.get_payment_periods();
    // Clientes 
    await this.catalogue.get_users_profile(9);
    this.clients = this.catalogue.users_profile;
    // Proveedores
    await this.catalogue.get_users_profile(2);
    this.providers = this.catalogue.users_profile;

  },
  created() {
    Event.$on("event-show-service-contract-form", async (payload) => {
      if (payload && payload.id) {
        await this.openForEdit(payload.id);
      } else {
        await this.openForCreate(payload || {});
      }
    });
  },
  computed: {
    ...mapGetters({
      'authUser': 'auth/user'
    })
  },
  watch: {
    'form.concepts': {
      handler() {
        this.calcHeaderTotal();
      },
      deep: true
    }
  }
}
</script>

<template>
  <modal name="serviceContractForm" :width="'90%'" :maxHeight="500" :height="'auto'" v-bind:click-to-close="false">
    <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
      <i class="fa-solid fa-xmark"></i>
    </button>

    <form @submit.prevent="saveServiceContract" method="post" enctype="multipart/form-data">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ form.id ? 'Editar contrato de servicio' : 'Nuevo contrato de servicio' }}
        </h5>
      </div>

      <div class="modal-body">
        <div class="row">
          <!-- Encabezado -->
          <div class="col-md-3 mt-3">
            <label>Tipo contrato</label>
            <select class="form-control" v-model="form.contract_type_id" :disabled="!prop_edit">
              <option value="">Selecciona una opción</option>
              <option v-for="(type, i) in catalogue.contract_services_type" :key="i" :value="type.id">
                {{ type.name }}
              </option>
            </select>
            <div v-if="errors && errors.contract_type_id" class="text-danger">{{ errors.contract_type_id[0] }}</div>
          </div>

          <div class="col-md-3 mt-3">
            <label>Proveedor</label>
            <select class="form-control" v-model="form.provider_id" :disabled="!prop_edit">
              <option value="">Selecciona una opción</option>
              <option v-for="(provider, i) in providers" :key="i" :value="provider.id">
                {{ provider.name }}
              </option>
            </select>
            <div v-if="errors && errors.provider_id" class="text-danger">{{ errors.provider_id[0] }}</div>
          </div>

          <div class="col-md-3 mt-3">
            <label>Cliente</label>
            <select class="form-control" v-model="form.client_id" :disabled="!prop_edit">
              <option value="">Selecciona una opción</option>
              <option v-for="(client, i) in clients" :key="i" :value="client.id">
                {{ client.name }}
              </option>
            </select>
            <div v-if="errors && errors.client_id" class="text-danger">{{ errors.client_id[0] }}</div>
          </div>

          <div class="col-md-3 mt-3">
            <label>Periodo de pago</label>
            <select class="form-control" v-model="form.payment_period_id" :disabled="!prop_edit">
              <option value="">Selecciona</option>
              <option v-for="(p, i) in catalogue.payment_periods" :key="i" :value="p.id">
                {{ p.name }}
              </option>
            </select>
            <div v-if="errors && errors.payment_period_id" class="text-danger">{{ errors.payment_period_id[0] }}</div>
          </div>

          <div class="col-md-6 mt-3">
            <label>Descripción del servicio</label>
            <input class="form-control" type="text" v-model="form.service_description" :disabled="!prop_edit" />
            <div v-if="errors && errors.service_description" class="text-danger">{{ errors.service_description[0] }}
            </div>
          </div>

          <div class="col-md-3 mt-3">
            <label>Fecha inicio</label>
            <date-picker v-model="form.start_date" :disabled="!prop_edit" required valueType="format"></date-picker>
            <div v-if="errors && errors.start_date" class="text-danger">{{ errors.start_date[0] }}</div>
          </div>

          <div class="col-md-3 mt-3">
            <label>Fecha fin</label>
            <date-picker v-model="form.end_date" :disabled="!prop_edit" valueType="format"></date-picker>
            <div v-if="errors && errors.end_date" class="text-danger">{{ errors.end_date[0] }}</div>
          </div>



          <div class="col-md-12 mt-3">
            <label>Términos</label>
            <textarea class="form-control" v-model="form.terms" :disabled="!prop_edit"></textarea>
            <div v-if="errors && errors.terms" class="text-danger">{{ errors.terms[0] }}</div>
          </div>

          <!-- Conceptos -->
          <div class="col-md-12 mt-4">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Conceptos</h5>
              <button v-if="prop_edit" type="button" class="btn btn-sm btn-outline-info" @click="addConceptRow()">
                <i class="fa fa-plus"></i> Agregar
              </button>
            </div>
            <hr class="mt-2">
          </div>

          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered text-sm table-striped">
                <thead>
                  <tr class="text-center">
                    <th>Concepto</th>
                    <th style="width:160px;">Monto</th>
                    <th style="width:120px;">Unidad</th>
                    <th style="width:160px;">Total</th>
                    <th style="width:90px;">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, idx) in form.concepts" :key="idx">
                
                    <td>
                      <input type="text" class="form-control" v-model="c.concept" :disabled="!prop_edit"
                        placeholder="Concepto" />
                      <div v-if="errors && errors[`concepts.${idx}.concept`]" class="text-danger">
                        {{ errors[`concepts.${idx}.concept`][0] }}
                      </div>
                    </td>

                    <td>
                       <money class="form-control" v-model="c.amount" :prefix="''"
                                                        :disabled="!prop_edit" @input="calcLineTotal(c)"></money>
                      <div v-if="errors && errors[`concepts.${idx}.amount`]" class="text-danger">
                        {{ errors[`concepts.${idx}.amount`][0] }}
                      </div>
                    </td>

                    <td>
                      <money class="form-control" v-model="c.quantity" :prefix="''"
                                                        :disabled="!prop_edit" @input="calcLineTotal(c)"></money>
                      <div v-if="errors && errors[`concepts.${idx}.quantity`]" class="text-danger">
                        {{ errors[`concepts.${idx}.quantity`][0] }}
                      </div>
                    </td>

                    <td>
                      <input type="number" step="0.01" class="form-control" :value="c.total" disabled />
                    </td>

                    <td class="text-center">
                      <button v-if="prop_edit" type="button" class="btn btn-sm btn-outline-danger"
                        @click="removeConceptRow(idx)" :disabled="form.concepts.length <= 1">
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="3" class="text-right">TOTAL</th>
                    <th class="text-center">
                      {{ (form.total_ui || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
                    </th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <!-- Botones -->
          <div class="col-md-12">
            <hr>
            <button v-if="prop_edit" :disabled="send" type="submit" class="btn float-right btn-outline-success">
              <i class="fas fa-save"></i> Guardar
            </button>
            <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
              <i class="fas fa-undo-alt"></i> Regresar
            </button>
          </div>

        </div>
      </div>
    </form>
  </modal>
</template>

<style scoped>
.btn-closed {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
}
</style>
